import { z } from 'zod';

export const investorDeclarationPostRequestSchema = z.object({ company: z.string(), investor_type: z.string() });
